import React, { FunctionComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Field } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/free-solid-svg-icons";
import {
  proceedToNextFormStep,
  goBack,
} from "../../../actions/diversityFormActions";
import RadioButton from "../../shared/publicForms/RadioButton";
import {
  StepWrapper,
  Title,
  ButtonsWrapper,
  BackButton,
  Button,
  DisabledButton,
  RadioButtonGroupWrapper,
  RadioButtonGroup,
} from "../styles/diversity-form-styles";

export interface IAgeProps {
  values: {
    age?: null | string;
  };
  proceedToNextFormStepAction: typeof proceedToNextFormStep;
  goBackAction: typeof goBack;
}

export const Age: FunctionComponent<IAgeProps> = ({
  proceedToNextFormStepAction,
  goBackAction,
  values,
}) => {
  const radioButtonOptionsLeft = [
    "16-24",
    "25-29",
    "30-34",
    "35-39",
    "40-44",
    "45-49",
  ];

  const radioButtonOptionsRight = [
    "50-54",
    "55-59",
    "60-64",
    "65+",
    "Prefer not to say",
  ];

  return (
    <StepWrapper data-test-id="age-step" formStep>
      <Title data-test-id="title">Into which age bracket do you fit?</Title>
      <RadioButtonGroupWrapper role="group" aria-labelledby="age-radio-group">
        <RadioButtonGroup width={185}>
          {radioButtonOptionsLeft.map((option) => (
            <Field
              key={option}
              name="age"
              type="radio"
              aria-label={option}
              label={option}
              value={option}
              as={RadioButton}
            />
          ))}
        </RadioButtonGroup>
        <RadioButtonGroup width={185}>
          {radioButtonOptionsRight.map((option) => (
            <Field
              key={option}
              name="age"
              type="radio"
              aria-label={option}
              label={option}
              value={option}
              as={RadioButton}
            />
          ))}
        </RadioButtonGroup>
      </RadioButtonGroupWrapper>
      <ButtonsWrapper>
        <BackButton type="button" onClick={goBackAction}>
          <FontAwesomeIcon icon={faChevronLeft} />
          back
        </BackButton>
        {values.age ? (
          <Button
            type="button"
            onClick={proceedToNextFormStepAction}
            data-test-id="next-button"
          >
            Next
          </Button>
        ) : (
          <DisabledButton type="button">Next</DisabledButton>
        )}
      </ButtonsWrapper>
    </StepWrapper>
  );
};

Age.propTypes = {
  values: PropTypes.shape({
    age: PropTypes.string,
  }).isRequired,
  proceedToNextFormStepAction: PropTypes.func.isRequired,
  goBackAction: PropTypes.func.isRequired,
};

export default connect(null, {
  proceedToNextFormStepAction: proceedToNextFormStep,
  goBackAction: goBack,
})(Age);
